import { AuthenticationContext, adalFetch, withAdalLogin} from 'react-adal';
//import dotenv from 'dotenv';
//dotenv.config();
import {tenant, clientId, redirectUri} from '../../Config/const'

export const endpoint =clientId;

export const adalConfig = {
    tenant: tenant,
    clientId: clientId,
    redirectUri:redirectUri,
    authority:"https://login.microsoftonline.com/"+tenant,
    endpoints: {
        api: endpoint,
    },
    cacheLocation: 'localStorage',
};

export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
    adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);

    
export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);